import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Container } from 'src/components/container';
import { breakpointLargeTablet, breakpointTablet } from 'src/styles/breakpoints';
import { spacing10, spacing11, spacing2, spacing3, spacing4, spacing5, spacing7 } from 'src/styles/spacing';

export const StyledProducts = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing4};
  justify-content: center;
`;

export const StyledTitle = styled(Typography)`
  text-align: center;
  padding-bottom: ${spacing2};
  padding-top: ${spacing5};

  @media (min-width: ${breakpointTablet}) {
    padding-bottom: ${spacing3};
  }
`;

export const StyledSubtitle = styled(Typography)`
  text-align: center;
  padding-bottom: ${spacing4};

  @media (min-width: ${breakpointTablet}) {
    padding-bottom: ${spacing7};
  }
`;

export const StyledContainer = styled(Container)`
  margin-bottom: ${spacing10};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-bottom: ${spacing11};
  }
`;
